// Custom
import i18next from 'i18next';
import GlobalForm from 'new_design/common/search_widget/search_form/global';

const $ = require('jquery');
const TAB_SEARCH_TYPES = ['all', 'sanatorii', 'camps'];
const TAB_SEARCH_TYPES_PLACEHOLDERS = {
  all: 'Название объекта или региона',
  sanatorii: 'Санаторий или курорт',
  camps: 'Название базы отдыха',
};

const PROJECT_TO_TAB_SEARCH_TYPE = {
  mt: 'camps',
  kx: 'sanatorii',
  ubook: 'all'
};

require('select2/dist/js/select2');
require('select2/dist/js/i18n/ru');

function handleClearChosenTreatment() {
  const $deceaseSelect = $('#camp_treatment_profiles');
  if ($deceaseSelect.length) {
    $deceaseSelect.val(null).trigger('change');
  }
}

$(document).ready(async function () {
  await GlobalForm.init('search-form', {
    TAB_SEARCH_TYPES,
    TAB_SEARCH_TYPES_PLACEHOLDERS,
    PROJECT_TO_TAB_SEARCH_TYPE
  });
  searchTogglerInit();
  deceaseSearchInit();
  window.isMobileDevice ? parseMobileTreatmentsList() : parseDesktopTreatmentsList();

  let search_data = await GlobalForm.getSearchData();

  $('.objects-choose-tab').on('click', function (e) {
    e.preventDefault();
    let $tabs = $('.objects-tabs__tab');
    let index = $tabs.index($(this));
    $tabs.removeClass('objects-tabs__tab-active');
    $tabs.eq(index).addClass('objects-tabs__tab-active');

    const tabSearchType = TAB_SEARCH_TYPES[index];
    $('#tab_search_type').val(tabSearchType);

    const treatmentField = $('#search-treatment-div');
    if (treatmentField.length) {
      index === 1 ? treatmentField[0].classList.remove('hidden') : treatmentField[0].classList.add('hidden');
    }

    const placeholderText = TAB_SEARCH_TYPES_PLACEHOLDERS[tabSearchType];

    const $searchString = $('#search_string');
    const $searchStringBase = $('#search_string_base');
    $searchString.attr('placeholder', placeholderText);

    if (!search_data.search_string) {
      $searchStringBase.html(placeholderText);
    }

    if (!$searchStringBase.text().trim()) {
      $searchStringBase.text(placeholderText).addClass('search-params-popup__string_placeholder');
    }


    if ($searchString.val() !== '') {
      $('.search_string').attr('placeholder', '');
    }
  });

  document.addEventListener('clear_chosen_treatment', handleClearChosenTreatment);
  $('#clear_chosen_treatment').on('click', handleClearChosenTreatment);

  const tags = $('.example-block__tag');

  tags.each(function () {
    $(this).on('click', function () {
      const selectedRegionId = $(this).data('region-id');
      const newValue = $(this).text().trim();
      $('.search-object').val(newValue).attr('value', newValue).trigger('input');
      $('#search_id').val(selectedRegionId).attr('value', selectedRegionId).trigger('input');
      $('#search_type').val('region').attr('value', 'region').trigger('input');
    });
  });
});

// Нажатие на лупу в хэдере открывает/скрывает поиск
function searchTogglerInit() {
  $('.open_search').on('click', function () {
    //$('.header-page-search-mob').fadeToggle();
  });
}

// Инициализация select2 для sanatorix
function deceaseSearchInit() {
  if (window.isMobileDevice) {
    addTagRemoveEvent();
    let $input = $('.search-item__treatment');

    if ($input.length === 0) return;

    $('#search-treatment .search-item_cancel').hide();

    const onInput = function (search_val) {
      $('#search-treatment .search-item_cancel').toggle(search_val.length > 0);
      $('.search-params-popup__treatment__item').each(function () {
        let show = search_val.length === 0 || $(this).text().toLowerCase().indexOf(search_val) !== -1;
        $(this).toggle(show);
      });
    };

    $input.on('input', function () {
      let search_val = $(this).val().toLowerCase();
      onInput(search_val);
    });
    $('#search-treatment .search-item_cancel').click(function () {
      $input.val('');
      onInput('');
    });
    $('.search-params-popup__treatment__item').click(function () {
      let $treatments_tags_list = $('.treatments-tags-list');
      $treatments_tags_list.prepend(
        `<div class="filter-tags-list__tag" data-treatment_id="${$(this).data('treatment_id')}">${$(this).text()}</div>`
      );
      let treatments_count = $treatments_tags_list.find('div').length;
      $('#camp_treatment_profiles_count').html(i18next.t('variant_chosen', { count: treatments_count }));
      addTagRemoveEvent();
      syncTreatments();
      $(this).hide();
    });

    hideChosenTreatments();
  } else {
    let decease_select = $('#camp_treatment_profiles');
    // Если открыли страницу, на которой нет виджета поиска
    if (decease_select.length === 0) {
      return;
    }

    let $clearChosenTreatmentSign = $('#clear_chosen_treatment');
    if (!decease_select.val()) {
      $clearChosenTreatmentSign.hide();
    }

    decease_select.on('change', () => {
      if (decease_select.val()) {
        $clearChosenTreatmentSign.show();
      } else {
        $clearChosenTreatmentSign.hide();
      }
    });

    let parent_decease_size = Number($('#parent_treatment_profiles_size').val());

    let select2_settings = {
      placeholder: 'Лечение',
      language: 'ru',
    };

    decease_select.select2(select2_settings);
    decease_select.attr('name', 'camp_treatment_profiles');
    // При открытии выпадающего списка
    decease_select.on('select2:open', function (e) {
      let decease_input = $('.select2-search__field');

      // При открытии селекта, до ввода, показываем только профили лечения
      $('.select2-results__option').hide();
      $(`ul .select2-results__option:nth-last-child(-n+${parent_decease_size})`).show();

      // Заполняем поиск уже выбранным значением
      decease_input.val(decease_select.select2('data')[0].text);
      // Выделяем весь текст
      decease_input.select();

      // Показываем кнопку очистки выбранного профиля только при заполненном соответсвующем поле
    });
  }
}

function syncTreatments() {
  const $treatments_tags_list = $('.treatments-tags-list');
  const treatments_count = $treatments_tags_list.find('div').length;
  $('#camp_treatment_profiles_count').html(i18next.t('variant_chosen', { count: treatments_count }));

  const treatments_tags_list_array = $treatments_tags_list.find('div').toArray();
  const names = treatments_tags_list_array.map((tag) => $(tag).text()).join(', ');
  const $treatment = $('.search-params-popup__treatment');
  if (names.length) {
    $treatment.text(names).removeClass('search-params-popup__treatment_placeholder');
  } else {
    $treatment.text('Выберите лечение').addClass('search-params-popup__treatment_placeholder');
  }

  const ids = treatments_tags_list_array.map((tag) => $(tag).data('treatment_id')).join(',');
  $('#camp_treatment_profiles_input').val(ids);
}

function addTagRemoveEvent() {
  $('.filter-tags-list__tag:not(.filter-tags-list__tag_prevent-remove)').click(function () {
    $(`.search-params-popup__treatment__item[data-treatment_id="${$(this).data('treatment_id')}"]`).show();
    $(this).remove();
    syncTreatments();
  });
}

/**
 * В селекте выбора лечения скрываем варианты, которые уже выбраны (данные из куки), - в мобильной версии в модальном окне;
 * Пояснение: если в куках лежат выбранные заболевания, они отобразятся в качестве элементов div без указания id'шников
 */
function hideChosenTreatments() {
  // Список выбранных заболеваний - div'ы без id в data
  const $treatments_tags_list = $('.treatments-tags-list');
  const treatments_tags_list_array = [
    ...$treatments_tags_list
      .find('div')
      .toArray()
      .map((tag) => $(tag).text().toLowerCase()),
  ];

  // Если есть выбранные заболевания
  if (treatments_tags_list_array.length) {
    // Очищаем от div'ов без id
    $treatments_tags_list.empty();

    // Добавляем div'ы с id'шниками:
    // для каждого варианта заболевания
    $('.search-params-popup__treatment__item').each(function () {
      /** @type {boolean} если ЛОЖЬ, значит вариант заболевания выбран и его надо скрыть из общего списка вариантов;
       * ИСТИНА - оставляем (если есть в списке выбранных заболеваний, поиск по названию) */
      let show =
        treatments_tags_list_array.length === 0 ||
        treatments_tags_list_array.indexOf(
          $(this)
            .text()
            .toLowerCase()
            .replace(
              /\s{3,}/g, // текст имеет отступы в начале и в конце, от которых мы избавляемся; между словами пробелы должны остаться
              ''
            )
        ) === -1;
      if (!show) {
        $treatments_tags_list.prepend(
          `<div class="filter-tags-list__tag" data-treatment_id="${$(this).data('treatment_id')}">` +
            `   ${$(this).text()}` +
            `</div>`
        );
        $(this).hide();
      }
    });
    addTagRemoveEvent();
    syncTreatments();
  }
}

function parseMobileTreatmentsList() {
  $('.search-params-popup__treatment').one('click', function (e) {
    $.post('/get_deceases_list', function (data) {
      $('#search-params-popup__treatment__items').html(data);
      deceaseSearchInit();
    });
  });
}

function parseDesktopTreatmentsList() {
  if (document.getElementById('select2-camp_treatment_profiles-container') === null) {
    $('.search-item__treatment').one('mouseenter', function (e) {
      $.post('/get_deceases_list_for_desktop', function (data) {
        $('.search-item__treatment').append(data);
        $('.treatment_paragraph').hide();
        deceaseSearchInit();
        $('#clear_chosen_treatment').on('click', () => {
          let $decease_select = $('#camp_treatment_profiles');
          if ($decease_select.length !== 0) {
            $decease_select.val(null);
            $decease_select.trigger('change');
          }
        });
      });
    });
  }
}
